import React from "react";
import Navibar from "../components/Navibar";
import Footer from "../components/Footer";
import Boxes from "../components/Boxes";
import Artcircle from "../components/Artcircle";

import Certifications from "../components/Certifications";

export default function VSKQuality() {
  return (
    <>
      <Navibar />
     
      <div class="main-banner">
        <div class="d-table">
          <div class="d-table-cell">
            <div class="container">
              <div class="row h-100 justify-content-center align-items-center">
                <div class="col-lg-5">
                  <div class="hero-content pt-5">
                    <h1>Every Thread Counts</h1>
                    <p>
                      We envision a future where our brand is synonymous with
                      quality and innovation, shaping trends and inspiring
                      customers worldwide..
                    </p>
                  </div>
                </div>

                <div class="col-lg-6 offset-lg-1">
                  <div class="banner-image">
                    <img
                      src="/img/quality.jpg"
                      class="wow fadeInRight"
                      data-wow-delay="0.6s"
                      alt="home-pic"
                    />

                    <img
                      src="/img/quality.jpg"
                      class="wow fadeInUp"
                      data-wow-delay="0.6s"
                      alt="main-pic"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Boxes />

      <Artcircle />

      <Certifications />
      <Footer />
    </>
  );
}
